import { __extends } from "tslib";
import React from 'react';
import { Components, } from '@singularsystems/neo-core';
import ComponentBase from './ComponentBase';
var CollapsableBase = /** @class */ (function (_super) {
    __extends(CollapsableBase, _super);
    function CollapsableBase(props) {
        var _this = _super.call(this, props) || this;
        _this.containerRef = React.createRef();
        _this.shouldShow = false;
        _this.onClose = _this.onClose.bind(_this);
        return _this;
    }
    CollapsableBase.prototype.onClose = function (e) {
        this.props.bindShow.value = false;
    };
    CollapsableBase.prototype.afterRender = function (isInitial) {
        var _this = this;
        if (this.timer)
            clearTimeout(this.timer);
        if (this.containerRef.current) {
            if (!this.animationHelper) {
                this.animationHelper = new Components.CollapseAnimationHelper(this.containerRef.current, this.shouldShow, this.props.state, this.props.onHidden);
            }
            if (!isInitial || this.props.animateInitial) {
                this.animationHelper.showHide(this.shouldShow, isInitial && this.props.animateInitial);
            }
        }
        if (this.shouldShow && this.props.autoCloseTimeout && this.props.bindShow) {
            this.timer = setTimeout(function () {
                _this.props.bindShow.value = false;
            }, this.props.autoCloseTimeout);
        }
    };
    CollapsableBase.prototype.componentWillUnmount = function () {
        if (this.animationHelper) {
            this.animationHelper.destroy();
        }
    };
    return CollapsableBase;
}(ComponentBase));
export default CollapsableBase;
